
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getCreateDocumentsubtypeDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    documenttypeId: new FormControl<number | undefined>(undefined),
})
;
}
      